<div class="space-y-4">
  @for (entry of fieldEntries(); track entry[0]) {
    @let fieldKey = entry[0];
    @let config = entry[1];

    <div>
      @switch (config.type) {
        @case ('text') {
          <app-text
            [label]="config.title"
            [placeholder]="config.placeholder ?? ''"
            [required]="isRequired(fieldKey)"
            [help]="config.description ?? undefined"
            [value]="getFieldValue(fieldKey)"
            (valueChange)="updateField(fieldKey, $event)"
          />
        }
        @case ('select') {
          <app-select
            [label]="config.title"
            [options]="getOptions(config.options)"
            [required]="isRequired(fieldKey)"
            [help]="config.description ?? undefined"
            [selected]="getFieldValue(fieldKey)"
            (selectedChange)="updateField(fieldKey, $event)"
          />
        }
        @case ('number') {
          <app-number
            type="number"
            [label]="config.title"
            [placeholder]="config.placeholder ?? ''"
            [required]="isRequired(fieldKey)"
            [help]="config.description ?? ''"
            [value]="getFieldValue(fieldKey)"
            [min]="config.min ?? undefined"
            [max]="config.max ?? undefined"
            (valueChange)="updateField(fieldKey, $event)"
          />
        }
      }
    </div>
  }

  @for (note of notes(); track $index) {
    <app-alert>{{note}}</app-alert>
  }

</div>
